import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authToken: "",
    isAuthSet: false,
  },
  mutations: {
    setAuthToken(state, payload) {
      state.authToken = payload;
    },
    setIsAuthSet(state, payload) {
      state.isAuthSet = payload;
    }
  },
  actions: {
    getAuthToken({ commit }) {
      const theCookie = document.cookie.split(";").filter((item) => {
        if (item.includes("authToken=")) return true;
      })
      if (theCookie.length === 0) {
        return false;
      }

      commit("setAuthToken", theCookie[0].split("=")[1])
    },
    checkAuthToken({commit}) {
      if (document.cookie.split(';').filter(item => {
        if (item.includes('authToken=')) return true
      }).length) { commit('setIsAuthSet', true) } else { commit('setIsAuthSet', false) }
    },
    requestAuthToken({ commit }) {
      axios
      .get(process.env.VUE_APP_API + "/card/get-token.php")
      .then((response) => {
        document.cookie = "authToken=" + response.data.token + "; max-age=3600; SameSite"
        commit("setAuthToken", response.data.token)
      })
    },
    checkSetAuthToken({dispatch, commit, state}) {
      dispatch('checkAuthToken')
      if(!state.isAuthSet) {
        dispatch('requestAuthToken')
      } else {
        dispatch('getAuthToken')
      }
    },
    expiredToken() {
      if(confirm("Your Authorization Token is Expired. Please refresh the page and try again.")) {
        location.reload();
      }
    }
  },
});